import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=80cb4c38&"
import script from "./Buttons.vue?vue&type=script&lang=js&"
export * from "./Buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80cb4c38')) {
      api.createRecord('80cb4c38', component.options)
    } else {
      api.reload('80cb4c38', component.options)
    }
    module.hot.accept("./Buttons.vue?vue&type=template&id=80cb4c38&", function () {
      api.rerender('80cb4c38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/basic-ui/Buttons.vue"
export default component.exports